<template>
  <div class="col-md-4 ml-auto mr-auto">
    <form @submit.prevent="login">
      <card class="card-login card-plain">

        <div slot="header">
          <div class="logo-container">
            <img src="/img/svg/login.svg" alt="login-logo" >
          </div>
        </div>

        <div>
          <!-- change this back to email -->
          <fg-input v-model="model.email"
                    v-validate="'required'" 
                    name="email"
                    :error="getError('email')"
                    class="no-border form-control-lg"
                    placeholder="example@kristujayanti.com"
                    addon-left-icon="now-ui-icons ui-1_email-85">
          </fg-input>

          <fg-input v-model="model.password"
                    v-validate="'required|min:6'"
                    type="password"
                    name="password"
                    :error="getError('password')"
                    class="no-border form-control-lg"
                    placeholder="Your Password"
                    addon-left-icon="now-ui-icons ui-1_lock-circle-open">
          </fg-input>
        </div>

        <div slot="footer">
          <n-button native-type="submit" type="danger" round block>
            Login to Dashboard
          </n-button>
          <!-- <div class="pull-left" >
            <h6>
              <router-link class="link footer-link" to="/register">
                Create Account
              </router-link>
            </h6>
          </div> -->
          <div class="text-center mt-2">
            <router-link tag="a" to="/auth/forgot" class="link footer-link">Forgot Password?</router-link>
          </div>
        </div>
      </card>
    </form>
  </div>
</template>
<script>
export default {
  name: 'login',
  data() {
    return {
      model: {
        email: '',
        password: ''
      }
    };
  },
  methods: {
    getError(fieldName) {
      return this.errors.first(fieldName);
    },
    async login() {
      let isValidForm = await this.$validator.validateAll();
      if (isValidForm) {
        let prefix = this.model.email.substr(0, this.model.email.indexOf('@'));
        let suffix = this.model.email.substr(this.model.email.indexOf('@'), this.model.email.length);
        let first2 = this.model.email.substr(0,2);

        if(Number.isInteger(Number(first2))){
          // email is a student registered email address
          this.model.email = prefix.toUpperCase()+suffix;
        }

        this.$store.dispatch('attemptAuth', this.model)
      }
    }
  }
};
</script>

<style scoped>
.navbar-nav .nav-item p {
  line-height: inherit;
  margin-left: 5px;
}
</style>
